import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { forwardRef } from 'react'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import hunnyKeyframes from 'theme/keyframes'

type OpenType = keyof typeof hunnyKeyframes

interface OpenEffectMixinProps {
  openType?: OpenType
  duration?: number
  delay?: number
}

export const openEffectMixin = ({
  openType = 'fade',
  duration = 0.3,
  delay = 0,
}: OpenEffectMixinProps = {}): FlattenSimpleInterpolation => css`
  animation: wait ${delay}s, ${hunnyKeyframes[openType]} ${duration}s ${delay}s;

  @keyframes wait {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`
const StyledContainer = styled(Box)<{ openType: OpenType; duration: number; delay: number }>`
  ${({ openType, duration, delay }) => openEffectMixin({ openType, duration, delay })}
`

export const OpenEffect = forwardRef<
  HTMLDivElement,
  { openType?: OpenType; duration?: number; delay?: number } & BoxProps
>(({ children, openType = 'fade', duration = 0.3, delay = 0, ...props }, ref) => {
  return (
    <StyledContainer ref={ref} openType={openType} duration={duration} delay={delay} {...props}>
      {children}
    </StyledContainer>
  )
})

export default OpenEffect
